<template>
    <div>
        <div class="content">
            <img src="@/assets/members_img.svg" class="img_photos" alt="">

        </div>

        <div class="content">
            <img src="@/assets/new_member.svg" alt="今年入社の先輩たち" width="300px">
            <div class="bold_message">
                <h3>少し前まで<br>
                    あなたと同じ立場だった<br>
                    先輩たち。<br>
                    あなたの<br>
                    ちょっと未来の<br>
                    姿かもしれません。</h3>
            </div>
        </div>
        <div class="content">
            <div class="pickup_items" v-if="!isInterview[0] && !isInterview[1]">
                <div class="middle_item" v-for="(member, index) in younger" :key=index
                    @click="handleOpenInterview(index)">
                    <h5>{{ member.role }}</h5>
                    <h3>{{ member.name }}</h3>
                    <div class="face_image" v-if="member.face">

                        <img :src="`/face/${member.face}`" width="180px" alt="">
                    </div>
                </div>

            </div>

            <div v-if="isInterview[0]">
                <InterviewBox @interview_close="handleOpenInterview(0)" :person=younger[0] />
            </div>
            <div v-if="isInterview[1]">
                <InterviewBox @interview_close="handleOpenInterview(1)" :person=younger[1] />
            </div>
            <div v-if="isInterview[2]">
                <InterviewBox @interview_close="handleOpenInterview(2)" :person=younger[2] />
            </div>


        </div>

        <div class="content">
            <img src="@/assets/teacher.svg" alt="MIKの教育担当" width="300px">

            <div class="bold_message">
                <h3>私たちが<br>
                    責任を持って<br>
                    エンジニアに育てます。<br>
                    少し大変かもしれませんが<br>
                    エンジニアになる日を信じて<br>
                    一緒に頑張っていきましょう。</h3>
            </div>
        </div>


        <div class="content">


            <div class="pickup_items" v-if="!isInterview[3]">


                <div class="middle_item" @click="handleOpenInterview(3)">
                    <div>
                        <h5>{{ edu_team[0].role }}</h5>
                        <h3>{{ edu_team[0].name }}</h3>
                        <div class="face_image">
                            <img :src="`/face/${edu_team[0].face}`" width="180px" alt="">
                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div v-if="isInterview[3]">
            <InterviewBox @interview_close="handleOpenInterview(3)" :person=edu_team[0] />
        </div>

        <div class="content">
            <img src="@/assets/leader.svg" alt="MIKのリーダーたち" width="300px">

            <div class="bold_message">
                <h3>配属後は<br>
                    私たちがあなたを<br>
                    現場のエンジニアに育てます。<br>
                    色々な現場を知りながら<br>
                    エンジニアとして成長していきましょう。</h3>
            </div>
        </div>

        <div class="content">

            <div class="pickup_items" v-if="!isInterview[4] && !isInterview[5] && !isInterview[6]">

                <div class="middle_item" v-for="(member, index) in leader" :key=index
                    @click="handleOpenInterview(index + 4)">
                    <h5>{{ member.role }}</h5>
                    <h5>{{ member.career }}</h5>
                    <h3>{{ member.name }}</h3>
                    <div class="face_image" v-if="member.face">

                        <img :src="`/face/${member.face}`" width="180px" alt="">
                    </div>
                </div>

            </div>
            <div v-if="isInterview[4]">
                <InterviewBox @interview_close="handleOpenInterview(4)" :person=leader[0] />

            </div>
            <div v-if="isInterview[5]">
                <InterviewBox @interview_close="handleOpenInterview(5)" :person=leader[1] />

            </div>
            <div v-if="isInterview[6]">
                <InterviewBox @interview_close="handleOpenInterview(6)" :person=leader[2] />

            </div>
        </div>

        <div class="content">
            <img src="@/assets/families.svg" alt="MIKの仲間たち" width="300px">

            <div class="bold_message">
                <h3>札幌、盛岡、東京、大阪、福岡の<br>
                    5拠点でMIKの仲間が<br>
                    活躍しています。
                </h3>
            </div>
        </div>

        <div class="content">

            <div class="pickup_items" v-if="!isInterview[7]">
                <div class="middle_item" v-for="(member, index) in members" :key=index @click="handleOpenInterview(7)">
                    <h5>{{ member.role }}</h5>
                    <h5>{{ member.area }}</h5>
                    <h3>{{ member.name }}</h3>
                    <div class="face_image" v-if="member.face">

                        <img :src="`/face/${member.face}`" width="180px" alt="">
                    </div>
                </div>

            </div>
            <div v-if="isInterview[7]">
                <InterviewBox @interview_close="handleOpenInterview(7)" :person=members[0] />

            </div>
        </div>


    </div>
</template>
<script>
import InterviewBox from './InterviewBox.vue';
import messages from '@/assets/members_message.json'

export default {

    components: { InterviewBox },
    data() {
        return {
            isInterview: [false, false, false, false, false, false, false, false, false, false, false],
            edu_team: [{ name: "", role: "", career: "", face: "" }],
            leader: [{ name: "", role: "", career: "", face: "" }],
            younger: [{ name: "", role: "", career: "", face: "" }],
            members: [],


        }
    },
    mounted() {
        this.edu_team = messages.education_team;
        this.leader = messages.leaders;
        this.younger = messages.youngers;
        this.members = messages.members;

    },



    methods: {
        handleOpenInterview(num) {
            this.isInterview = this.isInterview.map((_, index) => index === num ? !this.isInterview[num] : false)
            console.log(this.isInterview[0])
        },

    }
}
</script>
<style>
.bold_message {
    line-height: 40px;

}

.face_image {
    margin-top: 10px;
}

.middle_item h5,
h3 {
    margin: 0px;
}

.middle_item {
    width: 220px;
    height: 250px;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    margin: 20px;
    text-align: center;
    border: 2px solid black;
    position: relative;
    transition: 300ms;
}

.middle_item:hover {
    transition: 300ms;
    transform: scale(1.05)
}
</style>